import { Avatar, Button, List, ListItem, ListItemAvatar, ListItemText, Tooltip } from "@material-ui/core";
import React from "react";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import ClearIcon from "@material-ui/icons/Clear";
import InsertCommentIcon from "@material-ui/icons/InsertComment";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import { combineProps } from "../../../../helpers/objectHelper";
import { ChatAvatar } from "../../ChatModule/components/ChatAvatar";
export function Speaker(props) {
  const { speakers, activeSpeaker, agenda, template, settings, orderList, orderId } = props;
  const activeAgendaRow = agenda.find((a) => a.active === true);
  if (!activeAgendaRow && !activeSpeaker) return null;

  const { allowPointOfOrder, allowRequestLineOfSpeaker, allowRequestTheFloor } = settings;


  

  return (
    <List style={{ padding: 0 }}>
      {speakers
        .filter((s) => s.agendaItemId === activeAgendaRow.agendaItemId && s.active === true)
        .map((s, i) => {
          return (
            <div key={i}>
              <ListItem>
                <ListItemAvatar>
                  <ChatAvatar
                    {...combineProps([
                      props,
                      {
                        target: activeSpeaker?.badgeNo,
                      },
                    ])}
                  >
                    <PersonRoundedIcon />
                  </ChatAvatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <span style={template ? { ...template.label } : {}}>
                      <EventLabel2 name="CurrentSpeaker" groupName="DigitalMeeting.Agenda" />
                    </span>
                  }
                  secondary={<span style={template ? { ...template.label } : {}}>{activeSpeaker ? activeSpeaker.name : ""}</span>}
                />
              </ListItem>
              {allowRequestLineOfSpeaker == true  && s.speakerType == 1 ? <ActiveSpeakerControls {...combineProps([props, s])} /> : null}
            </div>
          );
        })}
    </List>
  );
}

const ActiveSpeakerControls = (props) => {
  const {
    isAuthorizedSpeaker,
    allowSpeaker,
    badgeNo,
    template,
    speakerType,
    clientKey,
    interactionSpeakerId,
    hasRequestedTheFloor,
    requestTheFloor,
    isSpeakerActive,
    unassignRequest,
    agendaItemId,
    orderId,
  } = props;
  if (!isAuthorizedSpeaker() && !allowSpeaker) return null;
  if (badgeNo == clientKey && speakerType == 2) return null;

  const hasRequested = hasRequestedTheFloor(agendaItemId, interactionSpeakerId);
  if (!hasRequested) {
    return (
      <Button
        variant="contained"
        disabled={orderId == 1}
        style={
          template
            ? {
                ...template.button,
                margin: "5px 10px",
                width: "90%",
                minWidth: "200px",
                maxWidth: "230px",
              }
            : {
                color: "rgba(64, 61, 61, 0.87)",
                borderRadius: 0,
                margin: "5px 10px",
                minWidth: "200px",
                maxWidth: "230px",
                boxShadow: "none",
                border: " 1px solid #b7b7b7",
                backgroundColor: "white",
              }
        }
        startIcon={<InsertCommentIcon />}
        edge="end"
        onClick={() => requestTheFloor(agendaItemId, 2, interactionSpeakerId)}
      >
        <Tooltip title={<EventLabel2 name="RequestTheFloor" groupName="DigitalMeeting.Agenda" />}>
          <EventLabel2 name="LineOfSpeaker" groupName="DigitalMeeting.Agenda" />
        </Tooltip>
      </Button>
    );
  } else {
    const isActiveSpeaker = isSpeakerActive(agendaItemId);
    return (
      <Button
        disabled={isActiveSpeaker}
        variant="contained"
        style={
          template
            ? {
                ...template.button,
                margin: "5px 10px",
                minWidth: "200px",
                maxWidth: "230px",
                opacity: isActiveSpeaker ? 0.6 : 1,
              }
            : {
                color: "rgba(64, 61, 61, 0.87)",
                borderRadius: 0,
                boxShadow: "none",
                border: " 1px solid #b7b7b7",
                backgroundColor: "white",
              }
        }
        startIcon={<ClearIcon />}
        onClick={() => unassignRequest(agendaItemId, interactionSpeakerId)}
      >
        <Tooltip title={<EventLabel2 name="UnassignRequest" groupName="DigitalMeeting.Agenda" />}>
          <EventLabel2 name="DeleteRequest" groupName="DigitalMeeting.Agenda" />
        </Tooltip>
      </Button>
    );
  }
};
